module.exports = __webpack_public_path__ + "static/media/55_000059.ae058800.jpg";